<template>
  <v-layout>
    <v-app>
      <navegacion-menu></navegacion-menu>
      <v-main>
        <dashboard-page></dashboard-page>
      </v-main>
    </v-app>
  </v-layout>
</template>

<script>
import navegacionmenu from "./NavegacionMenu.vue";
import store from "@/store";
import paginas from "./Paginas.vue";
import { onMounted, ref, watch } from "vue";
import { useIdle } from "@vueuse/core";
var singout = false;
export default {
  name: "vista-general",
  components: {
    "navegacion-menu": navegacionmenu,
    "dashboard-page": paginas,
  },
  data: () => ({
    cerrar: false,
  }),
  watch: {
    // Si no activan la sesión se cierra el aplicativo
    cerrar(newQuestion, oldQuestion) {
      this.$swal({
        icon: "info",
        title: "Sesión Caducada",
        html: "Su sesión se ha cerrado por tiempo de inactividad. Vuelva a acceder",
      });
      singout = false;
      this.$router.replace({ path: "/" });
      localStorage.removeItem("infouser");
      localStorage.removeItem("registromenu");
      localStorage.removeItem("infoperfil");
      localStorage.removeItem("paginainfo");
      localStorage.removeItem("token");
      this.axios.defaults.baseURL = "";
      this.axios.defaults.headers.common["Authorization"] = "";
      this.axios.defaults.timeout = 0;
    },
  },
  created() {
    const infoToken = localStorage.getItem("token");
    if (infoToken) {
      this.axios.defaults.baseURL = this.$store.state.apiService;
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + infoToken;
      this.axios.defaults.timeout = 60000;
    }
    var interval = setInterval(() => {
      if (singout) {
        this.cerrar = singout;
        clearInterval(interval);
      }
    }, 100000);
  },
  setup() {
    const app_idle = ref(false);
    var TiempoInactividad =
      store.getters.userperfil.userInfo.TiempoSesionInactivaMilisegundos;
    const { idle, lastActive } = useIdle(TiempoInactividad); // Tiempo de la sesión
    onMounted(() => {
      watch(idle, (v) => {
        if (idle.value === true) {
          app_idle.value = true;
          singout = true;
        }
      });
    });
    return { app_idle };
  },
};
</script>
<style>
.col {
  padding-bottom: 0 !important;
}
.swal2-container {
  z-index: 20000 !important;
}
</style>
